angular.module('bmsApp.accounting').factory('InvoiceDeliveryMethodSvc', function (CRUDSvc) {

	return {
		options: function () {
			return CRUDSvc.get('api/invoiceDeliveryMethod/options');
		}
	};

});